import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxTreeViewComponent } from 'devextreme-angular';
import { ToastService } from 'ng-uikit-pro-standard';
import { DeltaworldService } from 'src/app/services/deltaworld.service';
import { EstimateService } from 'src/app/services/estimate.service';
import { TranslateService } from '@ngx-translate/core';
import { MapInformationService } from "src/app/services/map-information.service";
@Component({
  selector: 'app-system-controller',
  templateUrl: './system-controller.component.html',
  styleUrls: ['./system-controller.component.scss']
})
export class SystemControllerComponent implements OnInit {
  @Input() popupController = false;
  modelController = {
    ID: "",
    RS485NET1FROM: "",
    RS485NET1TO: "",
    RS485NET2FROM: "",
    RS485NET2TO: "",
    SystemID: "",
    BACADD: "",
    MACADD: "",
    SOP: "",
    SCOPEOFWORK: "",
    CUBEBOXNUMBER: "",
    NETPARENTID: "",
    SHOWINSOW: true
  };
  modelSystemInformation = {
    systemid: "0",
    area: "",
    areaid: "",
    systemtype: 0,
    systemname: "",
    controldrawing: "",
    controldwimg: "",
    sort: "",
    qty: "",
    active: false,
    SystemBarName: '',
    MarkLib: false,
    SOP: null,
    DESCRIPTION: '',
    TAGNUM: '',
    TAGTEXT: '',
    SystemTypeid: 0,
    id: 0,
  };
  @Input() systemTypeSelectCE = [];
  @Input() areaSelect = [];
  @Input() imgSelected = 'Not_Image';
  treeBoxValue: string[];
  @ViewChild(DxTreeViewComponent, { static: false }) treeView;

  _systemid;
  imgbase64: string;
  changeimage: boolean;
  filename: string;
  SyncTags: { icon: string; type: string; onClick: () => void; };
  @Input('systemid')
  set systemid(systemid: any) {
    this._systemid = systemid;
    if(systemid != 0 && systemid != undefined){
      this.getControllerData(systemid);
    }
  }

  get systemid(): any { return this._systemid; }
  @Output() onclosemodal = new EventEmitter();
  @Output() onupdate = new EventEmitter();



  saveButtonEditController: any;
  cancelButtonEditController: any;
  value: any[] = [];

  constructor(
    private deltaService: DeltaworldService,
    private toast: ToastService,
    private estimateService: EstimateService,
    private MapInformationService: MapInformationService,
    private translate:TranslateService) { }

  ngOnInit() {
    this.cancelButtonEditController = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        this.popupController = false;
        this.value = []
        this.filename = null;
        this.changeimage = false;
        this.imgbase64 = null;
        this.value = [];
        this.imgSelected = 'Not_Image'
        console.clear()
        this.onupdate.emit();
      },
    };

    this.saveButtonEditController = {
      text: this.translate.instant('btnSave'),
      icon: "check",
      elementAttr: {
        id: "bton-green",
      },
      onClick: () => {
        // this.type = 1;
        // this.addNewComment();
        this.updateControllerData();
      },
    };


    this.SyncTags = {
      icon: "refresh",
      type: "button",
      onClick: () => {
        this.upateTag()
      },
    };
  }

  CancelPopup(){
    this.popupController = false;
    this.value = []
    this.filename = null;
    this.changeimage = false;
    this.imgbase64 = null;
    this.value = [];
    this.imgSelected = 'Not_Image'
    console.clear()
    this.onupdate.emit();
  }

  updateControllerData() {
    console.log(this.modelSystemInformation)
    this.deltaService
      .UpdateEstimateDetBACData(
        this.modelController.SystemID,
        this.modelController.BACADD,
        this.modelController.MACADD,
        this.modelController.RS485NET1FROM,
        this.modelController.RS485NET1TO,
        this.modelController.RS485NET2FROM,
        this.modelController.RS485NET2TO,
        this.modelController.CUBEBOXNUMBER,
        this.modelController.NETPARENTID
      )
      .subscribe((result) => {
        this.toast.success(this.translate.instant('ModalSysControll.msgUpdSucc'));
        this.popupController = false;
      });

    this.estimateService
      .Upadte_EstimateAreaSystemCEAreaid(
        this.modelSystemInformation.systemid,
        this.modelSystemInformation.systemid,
        this.modelSystemInformation.sort,
        this.modelSystemInformation.area,
        this.modelSystemInformation.areaid,
        this.modelSystemInformation.systemname,
        this.modelSystemInformation.qty,
        this.modelSystemInformation.SystemTypeid[0] != undefined ? this.modelSystemInformation.SystemTypeid[0]:this.modelSystemInformation.SystemTypeid,
        !this.modelSystemInformation.active, // Ponemos el caso contrario porqu eel campo se llama inactive en bd y active en el front
        false, //deleted
        "", //scope
        this.modelSystemInformation.SOP,
        this.modelSystemInformation.MarkLib,
        this.modelSystemInformation.controldrawing,
        this.modelSystemInformation.controldwimg, // img
        this.modelSystemInformation.TAGTEXT,
        this.modelSystemInformation.TAGNUM,
        this.modelSystemInformation.DESCRIPTION
      )
      .subscribe((result) => {
        // cantidadTerminada++;

        // if (cantidadTerminada >= cantidadLlamadas) {
        //   this.toast.success(this.translate.instant('msgUpdSucc'));
        //   this.popupEditAreaSystem = false;
        this.value = [];
        // this.imgSelected = "Not_Image"
        this.onupdate.emit();
        if (this.changeimage) {
          // this.uploadingimage = true;
          this.estimateService.SaveImageSystem(this.imgbase64, this.systemid).subscribe(res => {
            // this.onupdated.emit(this.componentModel);
            this.filename = null;
            this.changeimage = false;
            this.imgbase64 = null;
            // this.uploadingimage = false;
            this.value = [];
            // this.imgSelected = "Not_Image"
            this.onupdate.emit();
            console.clear()
          });
        }
        // }
      });


  }

  getControllerData(id) {
    if(id != 0 && id != undefined){
      this.deltaService.GetControllerMasterData(id).subscribe((result) => {
        let obj = result[0];
        this.getImageNew()
        console.log("🚀 ~ file: system-controller.component.ts:186 ~ SystemControllerComponent ~ this.deltaService.GetControllerMasterData ~ obj:", obj)

        if (obj)
          this.modelController = {
            ID: obj.ID,
            RS485NET1FROM: obj.RS485NET1FROM,
            RS485NET1TO: obj.RS485NET1TO,
            RS485NET2FROM: obj.RS485NET2FROM,
            RS485NET2TO: obj.RS485NET2TO,
            SystemID: id,
            BACADD: obj.BACADD,
            MACADD: obj.MACADD,
            SOP: obj.SOP,
            SCOPEOFWORK: obj.SCOPEOFWORK,
            CUBEBOXNUMBER: obj.CUBEBOXNUMBER,
            SHOWINSOW: obj.SHOWINSOW,
            NETPARENTID: obj.NETPARENTID
          };

          this.deltaService.GetEstimateAreaSystemInfo(id).subscribe((result2) => {
        
            console.log(result2)
            let obj2 = result2[0];
    
            if (obj2) {
              this.modelSystemInformation = {
                systemid: id,
                area: obj2.AreaName,
                areaid: obj2.AREAID,
                systemtype: obj2.SystemTypeid,
                systemname: obj2.SystemName,
                controldrawing: obj2.Control_Drawing,
                sort: obj2.SORT,
                qty: obj2.QTY,
                active: !obj2.Active,
                SystemBarName: obj2.SystemBarName,
                MarkLib: obj2.MarkLib,
                SOP: obj2.SOP,
                DESCRIPTION: obj2.DESCRIPTION,
                SystemTypeid: Number(obj2.SystemTypeid),
                TAGNUM: obj2.TAGNUM,
                TAGTEXT: obj2.TAGTEXT,
                id: obj2.ID,
                controldwimg: obj2.CONTROLDWGIMG
              };
            }
        });

      });


      
    }
  }



  getImageNew(){
    this.MapInformationService.SaveInfoSites({method:"Get_SystemImagePath", systemid:this.systemid})
    .subscribe(resp=>{
      console.log(resp)
      if (resp.length > 0){
        console.log(resp[0].ImagePath)
        this.MapInformationService.GetDocument(resp[0].ImagePath).subscribe(result => {
          this.imgSelected = result.filestring ? result.filestring : 'Not_Image';
          console.log(result)
          console.log(this.imgSelected)
        })

      }
    })
  }

  changeFile(ev) {

    let str = this.getBase64(ev.value[0]);
  }

  getBase64(file) {
    // const mythis = this
    // var reader = new FileReader();
    // reader.readAsDataURL(file);
    // reader.onload = function () {
    //   let data = reader.result.toString().split(",");

    //   mythis.imgbase64 = data[1];
    //   mythis.imgSelected = data[1]
    //   mythis.changeimage = true;
    //   let ext = file.name.split('.');
    //   mythis.filename = mythis.systemid + '.' + ext[ext.length - 1];
    //   mythis.modelSystemInformation.controldwimg = mythis.systemid + '.' + ext[ext.length - 1];
    // };
    // reader.onerror = function (error) {

    // };

    const reader = new FileReader();

    reader.onload = (e: any) => {

      // let data = e.target.result.toString().split(",")

      // this.dataFinalBase64 = e.target.result.toString()
      // this.imgbase64 = data[1];
      // this.imgSelected = data[1]
      // this.changeimage = true;

      let data = e.target.result.toString().split(",")

      this.imgbase64 = data[1];
      this.imgSelected = data[1]
      this.changeimage = true;
      let ext = file.name.split('.');
      this.filename = this.systemid + '.' + ext[ext.length - 1];
      this.modelSystemInformation.controldwimg = this.systemid + '.' + ext[ext.length - 1];

    };
    reader.readAsDataURL(file);




  }

  BorrarDocument(){


    this.imgbase64 = null;
    this.imgSelected = 'Not_Image';
    this.modelSystemInformation.controldwimg = null
  }

  syncTreeViewSelection(e) {
    var component =
      (e && e.component) || (this.treeView && this.treeView.instance);

    if (!component) return;

    if (!this.treeBoxValue) {
      component.unselectAll();
    }

    if (this.treeBoxValue) {
      this.treeBoxValue.forEach(
        function (value) {
          component.selectItem(value);
        }.bind(this)
      );
    }
  }

  treeView_itemSelectionChanged(e) {

    this.modelSystemInformation.systemtype = e.itemData.SystemType
    this.modelSystemInformation.SystemTypeid = e.itemData.ID

    this.treeBoxValue = e.component.getSelectedNodeKeys();
  }

  clearModel(){
    this.modelSystemInformation = {
      systemid: "0",
      area: "",
      areaid: "",
      systemtype: 0,
      systemname: "",
      controldrawing: "",
      controldwimg: "",
      sort: "",
      qty: "",
      active: false,
      SystemBarName: '',
      MarkLib: false,
      SOP: null,
      DESCRIPTION: '',
      TAGNUM: '',
      TAGTEXT: '',
      SystemTypeid: 0,
      id: 0,
    };
  }

  upateTag(){
    this.MapInformationService.SaveInfoSites({method:"Get_Systemtags", systemid:this.systemid})
    .subscribe(resp=>{
      this.modelSystemInformation.TAGNUM = resp[0].TAGIDS
      this.modelSystemInformation.TAGTEXT = resp[0].TAGS
    })
  }

  goToTutorial(id){

    // let info = {
    //   method: 'Get_Training_Videos'
    // }

    // this.MapInformationService.MethodCallApiFlex(info).subscribe(resp => {
    //   console.log(resp)
    // })

    // let id = "CREATE-AND-VIEW-ESTIMATE"

    let url = window.location.href.split("#");
    let finalUrl = url[0] + `#/videoTutorial?numVideo=${id}`; 
    console.log(finalUrl)
    window.open(finalUrl, "_blank");

  }

  changeArea(obj) {

    console.log(obj)
    console.log(this.modelSystemInformation)
    if (obj && obj.selectedItem) {
      // this.partselected = obj.selectedItem.ID;
      this.modelSystemInformation.areaid = obj.selectedItem.ID
      this.modelSystemInformation.area = obj.selectedItem.AreaName
    } else {
      // this.partselected = null;
    }
  }

}
